import { useEffect } from 'react';
import ProfessionalService from '../../../services/professional_service';
import StudentService from '../../../services/student_service';
import ContactThematicAreaService from '../../../services/contactThematicArea_service';
import {
  buildInitialUser,
  buildInitialProfessional,
  buildInitialStudent,
} from '../utils/formInitializers';

const LoadUser = (vm) => {

  const otherInfoLists = async () => {
    try {
      if (!vm.user) return;
      vm.setFormDataUser(buildInitialUser(vm.user));
      const professional = await ProfessionalService.get(vm.user?.Id);
      if (vm.logout(professional)) return;
      if (professional) {
        vm.setFormDataUser((prev) => ({ ...prev, stage: 'Profesional' }));
        vm.setFormDataProfesional(buildInitialProfessional(professional));
      } else {
        const student = await StudentService.get(vm.user?.Id);
        if (vm.logout(student)) return;
        if (student) {
          vm.setFormDataUser((prev) => ({ ...prev, stage: 'Estudiante' }));
          vm.setFormDataEstudiante(buildInitialStudent(student));
        }
      }
      const listUserThematicArea =
        (await ContactThematicAreaService.getAll({ FK_Contact: vm.user?.Id })) ?? [];
      if (vm.logout(listUserThematicArea)) return;
      vm.setFormDataArea(listUserThematicArea.map((u) => u.FK_ThematicArea));
      if (vm.mode === 'view') vm.setUser(null);
    } catch (e) {
      vm.message(e?.message || e, "error");
    }
  }
  useEffect(() => {otherInfoLists()}, [vm.user, vm.mode]);
};

export default LoadUser;
